import { getLocalizationStringOfTypeService } from 'src/api/common'

const fetchLocalizationStrings = async () => {
  const res = await getLocalizationStringOfTypeService('course-ui')
  return res.data.languages
}

export const settingItemListTypeEnum = {
  STATIC: 0,
  DYNAMIC: 1,
}

export const settingItemTypeEnum = {
  SELECT: 0,
  TEXTFIELD: 1,
}

const getData = () => {
  return [
    /*  {
    type: 'language',
    title: 'Language',
    settingItems: [
      {
        title: 'Language',
        description: 'What language should the course be in?',
        key: 'languageCode',
        listType: settingItemListTypeEnum.STATIC,
        type: settingItemTypeEnum.SELECT,
        freeSolo: false,
        list: [
          { name: 'Arabic', value: 'ar' },
          { name: 'Chinese (Simplified)', value: 'zh-CN' },
          { name: 'Chinese (Traditional)', value: 'zh-TW' },
          { name: 'Czech', value: 'cs' },
          { name: 'Danish', value: 'da' },
          { name: 'Dutch', value: 'nl' },
          { name: 'English', value: 'en' },
          { name: 'Finnish', value: 'fi' },
          { name: 'French', value: 'fr' },
          { name: 'German', value: 'de' },
          { name: 'Italian', value: 'it' },
          { name: 'Korean', value: 'ko' },
          { name: 'Malay', value: 'ms' },
          { name: 'Norwegian', value: 'no' },
          { name: 'Polish', value: 'pl' },
          { name: 'Portuguese', value: 'pt' },
          { name: 'Romanian', value: 'ro' },
          { name: 'Russian', value: 'ru' },
          { name: 'Spanish', value: 'es' },
          { name: 'Swedish', value: 'sv' },
          { name: 'Thai', value: 'th' },
          { name: 'Turkish', value: 'tr' },
          { name: 'Vietnamese', value: 'vi' },
        ],
        defaultValue: { name: 'English', value: 'en' },
      },
    ],
  }, */
    {
      type: 'audience',
      title: 'Audience',
      settingItems: [
        {
          title: 'Audience',
          description: 'Who is the course for?',
          placeholder: 'Entrepreneurs, Beginner level yoga learners...',
          key: 'audience',
          type: settingItemTypeEnum.TEXTFIELD,
          list: [],
        },
      ],
    },

    {
      type: 'tone',
      title: 'Tone',
      settingItems: [
        {
          title: 'Tone',
          description: 'What tone would you like for the course content?',
          key: 'tone',
          listType: settingItemListTypeEnum.STATIC,
          type: settingItemTypeEnum.SELECT,
          freeSolo: false,
          list: [
            { name: 'Analytical', value: 'analytical' },
            { name: 'Conversational', value: 'conversational' },
            { name: 'Inspirational', value: 'inspirational' },
            { name: 'Professional', value: 'formal' },
            { name: 'Storytelling', value: 'storytelling' },
            { name: 'Thought-Provoking', value: 'thought-provoking' },
            { name: 'Warm', value: 'warm' },
            { name: 'Casual', value: 'casual' },
          ],

          defaultValue: { name: 'Professional', value: 'formal' },
        },
      ],
    },

    {
      type: 'quiz',
      title: 'Quiz',
      settingItems: [
        {
          title: 'Quiz',
          description:
            'How many quiz questions should the course include in the end?',
          key: 'finalQuizCount',
          listType: settingItemListTypeEnum.STATIC,
          type: settingItemTypeEnum.SELECT,
          freeSolo: false,
          list: [
            { name: '0', value: 0 },
            { name: '1', value: 1 },
            { name: '2', value: 2 },
            { name: '3', value: 3 },
            { name: '4', value: 4 },
            { name: '5', value: 5 },
            { name: '6', value: 6 },
            { name: '7', value: 7 },
            { name: '8', value: 8 },
            { name: '9', value: 9 },
            { name: '10', value: 10 },
            { name: '11', value: 11 },
            { name: '12', value: 12 },
            { name: '13', value: 13 },
            { name: '14', value: 14 },
            { name: '15', value: 15 },
            { name: '16', value: 16 },
            { name: '17', value: 17 },
            { name: '18', value: 18 },
            { name: '19', value: 19 },
            { name: '20', value: 20 },
            { name: '21', value: 21 },
            { name: '22', value: 22 },
            { name: '23', value: 23 },
            { name: '24', value: 24 },
            { name: '25', value: 25 },
            { name: '26', value: 26 },
            { name: '27', value: 27 },
            { name: '28', value: 28 },
            { name: '29', value: 29 },
            { name: '30', value: 30 },
          ],
          defaultValue: { name: '5', value: 5 },
        },
      ],
    },
    {
      type: 'feedback',
      title: 'Survey',
      settingItems: [
        {
          title: 'Survey',
          description:
            'How many feedback questions should the course include in the end?',
          key: 'finalSurveyCount',
          listType: settingItemListTypeEnum.STATIC,
          type: settingItemTypeEnum.SELECT,
          freeSolo: false,
          list: [
            { name: '0', value: 0 },
            { name: '1', value: 1 },
            { name: '2', value: 2 },
            { name: '3', value: 3 },
            { name: '4', value: 4 },
            { name: '5', value: 5 },
            { name: '6', value: 6 },
            { name: '7', value: 7 },
            { name: '8', value: 8 },
            { name: '9', value: 9 },
            { name: '10', value: 10 },
            { name: '11', value: 11 },
            { name: '12', value: 12 },
            { name: '13', value: 13 },
            { name: '14', value: 14 },
            { name: '15', value: 15 },
            { name: '16', value: 16 },
            { name: '17', value: 17 },
            { name: '18', value: 18 },
            { name: '19', value: 19 },
            { name: '20', value: 20 },
            { name: '21', value: 21 },
            { name: '22', value: 22 },
            { name: '23', value: 23 },
            { name: '24', value: 24 },
            { name: '25', value: 25 },
            { name: '26', value: 26 },
            { name: '27', value: 27 },
            { name: '28', value: 28 },
            { name: '29', value: 29 },
            { name: '30', value: 30 },
          ],

          defaultValue: { name: '1', value: 1 },
        },
      ],
    },
    {
      type: 'imageSettings',
      title: 'Images',
      description:
        'Decide if and how images should be included in a course.',
      settingItems: [
        {
          title: 'Image Source',
          description: 'Choose how images should be included in your course',
          key: 'imageSource',
          listType: settingItemListTypeEnum.STATIC,
          type: settingItemTypeEnum.SELECT,
          freeSolo: false,
          list: [
            { name: 'AI Generated Images', value: 'imageGen' },
            { name: 'No Images', value: 'none' },
          ],
          defaultValue: { name: 'AI Generated Images', value: 'imageGen' },
        },
        {
          // Not rendered; always sent with the default so the backend uses GPT Image 2.5
          title: 'AI Image Generation Model',
          key: 'imageGenerationModel',
          hidden: true,
          defaultValue: { name: 'GPT Image 2.5', value: 'gpt-image-2.5' },
        },
        {
          title: 'Image Style',
          description: 'How should be the image style?',
          key: 'imageStyle',
          listType: settingItemListTypeEnum.STATIC,
          type: settingItemTypeEnum.SELECT,
          freeSolo: false,
          list: [
            { name: 'Bokeh', value: 'bokeh' },
            { name: 'Cinematic', value: 'cinematic' },
            { name: 'Cartoon', value: 'cartoon' },
            { name: 'Illustration', value: 'illustration' },
            { name: 'Isometric', value: 'isometric' },
            { name: 'Minimalist', value: 'minimalist' },
            { name: 'Realistic photography', value: 'realistic photography' },
            { name: 'Simple line art', value: 'simple line art' },
            { name: 'Watercolor', value: 'watercolor' },
            { name: 'Modern', value: 'modern' },
          ],
          defaultValue: { name: 'Modern', value: 'modern' },
        },
        {
          title: 'Individuals Description',
          description: 'Extra keywords (Optional)',
          key: 'imageCharacter',
          listType: settingItemListTypeEnum.STATIC,
          type: settingItemTypeEnum.TEXTFIELD,
          list: [],
          defaultValue: {
            name: '',
            value: '',
          },
        },
      ],
    },
  ]
}

export default getData

